
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-4-ivh-oh-m-oh-cne-d-8-g-vk-4-b-fo-v.json") })
        }
      }, "path---projects-c-4-ivh-oh-m-oh-cne-d-8-g-vk-4-b-fo-v");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-4-ivh-oh-m-oh-cne-d-8-g-vk-4-b-fo-v!./.cache/json/projects-c-4-ivh-oh-m-oh-cne-d-8-g-vk-4-b-fo-v.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-4-ivh-oh-m-oh-cne-d-8-g-vk-4-b-fo-v!./.cache/json/projects-c-4-ivh-oh-m-oh-cne-d-8-g-vk-4-b-fo-v.json
// module chunks = 15178676390636814000